import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import PATH from "../config/PATH";
import { useEffect, useState, useRef } from "react";
import { Col, Row, Select, Spin } from "antd";
import ItemPackage from "../component/ItemPackage";
import { useDispatch, useSelector } from "react-redux";
import {
  getCurrentUser,
  getListPackage,
  getTurnRemain,
  registerRetailPackage,
  registerSubPackage,
} from "../Redux/futures/account/actions";
import {
  curStateAccount,
  curStateEvent,
  curStateHome,
  curStateMiniGame,
} from "../Redux/selector";
import ModalNotifycation from "../component/ModalNotifycation";
import { LoadingOutlined } from "@ant-design/icons";
import { mediaQueryPoint, useMediaQuery } from "../utils/hooks";
import { Option } from "antd/es/mentions";
// import iconFly from "../assets/images/Layer 64 copy 8.svg";
import styled from "styled-components";
// import { gsap } from "gsap";
import ModalNotifyByPackageSuccess from "../component/ModalNotifyByPackageSuccess";
// import AddItemEvent2024 from "./components/EventNewYearAndChristmas_2024/components/AddItem/AddItemEvent2024";
import ModalLogin from "../component/ModalLogin";
import { useLocation } from "react-router";
// import {
//   setOpenPopupAddSpin,
//   setOpenPopupAddSpinSuper,
// } from "../Redux/futures/thingyan-2025/action";
// import moment from "moment";
// import _ from "lodash";
import PopupMission from "./components/MiniGame/components/PopupFooter/PopupMission";
import { setPopupMission } from "../Redux/futures/mini-game/action";
import iconInfo from "../assets/images/Information--Streamline-Carbon.png";
import ModalInfoPage from "../component/ModalInfoPage";
import HomePage from "./HomePage";
import ModalNotiPackageErrorNewUser from "../component/ModalNotiPackageErrorNewUser";
import { TYPE_USER } from "../helper/const";
import IntroTourHome from "./components/components/IntroTourHome";
import UseResponsive from "@/utils/hooks/useResponsive";
import HeaderTurnRetailPackages, { ContactInfoHelper, TabPackage } from "./components/Package";
import iconConfirm from "@assets/web-v3-images/icon-confirm.png";
import iconError from "@assets/web-v3-images/not-lowest-unique.png";
import iconSuccess from "@assets/web-v3-images/icon-success.png";
import { useLoginModal } from '@/contexts/LoginModalContext';
/* global variables */
const TAB_KEYS = {
  SUB: "SUB",
  RETAIL: "RETAIL",
};

const PACKAGE_KEYWORD = {
  DAILY: "DAILY",
  WEEKLY: "WEEKLY",
  MONTHLY: "MONTHLY",
  SUB: "SUB",
};

/* global utils functions */
const checkSamePackage = (packId, pathname) => {
  if (pathname === PATH.PACKAGE_DAILY) {
    return packId.includes(PACKAGE_KEYWORD.DAILY);
  }

  if (pathname === PATH.PACKAGE_WEEKLY) {
    return packId.includes(PACKAGE_KEYWORD.WEEKLY);
  }

  if (pathname === PATH.PACKAGE_MONTHLY) {
    return packId.includes(PACKAGE_KEYWORD.MONTHLY);
  }

  return false;
};

const antIcon = (
  <LoadingOutlined style={{ fontSize: 50, color: "#fff" }} spin />
);

function PackagePage() {
  /* utils */
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const location = useLocation();

  /* media queries */
  const isMobile = useMediaQuery(`(max-width: ${mediaQueryPoint.lg}px)`);

  /* refs states */
  const isCheckPackRegister = useRef(null);
  const dataMiniAddCoins = useRef(null);

  /* redux states */
  const { typeIntroTour } = useSelector(curStateHome);
  const selectorAccount = useSelector(curStateAccount);
  // const { configEventLuckyMoon } = useSelector(curStateEvent) || {};
  const dataMiniGame = useSelector(curStateMiniGame);

  /* local states */
  const [tabActive, setTabActive] = useState("SUB");
  const [listPackage, setListPackage] = useState([]);
  const [isRegister, setIsRegister] = useState(false);
  const [stateNotification, setStateNotification] = useState({
    open: false,
    title: "",
    content: "",
  });
  const [dataSelect, setDataSelect] = useState(null);
  const [isCancelled, setIsCancelled] = useState(false);
  const [isConfirmation, setIsConfirmation] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isLogin, setIsLogin] = useState(false);
  const [openModalLogin, setOpenModalLogin] = useState(false);
  const [openModalInfo, setOpenModalInfo] = useState(false);
  const [isMissionFromMw, setIsMissionFromMw] = useState(false);
  const [stateSuccess, setStateSuccess] = useState({
    open: false,
    title: "",
    content: "",
  });
  const { openLogin } = useLoginModal();
  /* variables */
  const isShowPopupMissionMini = dataMiniGame.popupMission?.isShow;
  const isPackageDQ = [
    PATH.PACKAGE_DAILY,
    PATH.PACKAGE_WEEKLY,
    PATH.PACKAGE_MONTHLY,
    PATH.PACKAGE_SUB,
  ].includes(location.pathname)

  /* effects */
  useEffect(() => {
    // Nếu trên url có ?retail thì set tabActive là retail
    if (location.search === "?retail") {
      setTabActive(TAB_KEYS.RETAIL);
    }
    // Nếu trên url có ?is_mission_from_mw=1 thì set isMissionFromMw là true
    if (location.search === "?is_mission_from_mw=1") {
      setIsMissionFromMw(true);
    } else {
      setIsMissionFromMw(false);
    }
  }, [location.search]);

  // lấy danh sách gói
  useEffect(() => {
    dispatch(getListPackage({}));
    if (!selectorAccount.userInfo) {
      dispatch(getCurrentUser({ callback: afterGetUserInfo }));
    }
  }, []);

  // xử lý check gói đã đăng ký
  useEffect(() => {
    if (selectorAccount.remainTurn && listPackage) {
      listPackage.map((_item) => {
        const isCheckPackRegister = selectorAccount.remainTurn?.some(
          (item) => item?.pack_id === _item?.pack_id,
        );
        // if (isCheckPackRegister) {
        setIsRegister(isCheckPackRegister);
        // return;
        // }
      });
    }
  }, [selectorAccount.remainTurn, listPackage]);

  // xử lý lọc gói theo tab
  useEffect(() => {
    if (selectorAccount.listPackage && selectorAccount.listPackage.length > 0) {
      const listPackageRetail = selectorAccount.listPackage.filter(
        (it) => !it.cycle,
      );
      const listPackageSub = selectorAccount.listPackage.filter(
        (it) => it.cycle,
      );

      if (tabActive === TAB_KEYS.SUB) {
        setListPackage(listPackageSub);
        if (location.pathname === PATH.PACKAGE_DAILY) {
          return setListPackage(
            listPackageSub.filter((item) =>
              checkSamePackage(item.pack_id, PATH.PACKAGE_DAILY),
            ),
          );
        }

        if (location.pathname === PATH.PACKAGE_WEEKLY) {
          return setListPackage(
            listPackageSub.filter((item) =>
              checkSamePackage(item.pack_id, PATH.PACKAGE_WEEKLY),
            ),
          );
        }

        if (location.pathname === PATH.PACKAGE_MONTHLY) {
          return setListPackage(
            listPackageSub.filter((item) =>
              checkSamePackage(item.pack_id, PATH.PACKAGE_MONTHLY),
            ),
          );
        }

        if (location.pathname === PATH.PACKAGE_SUB) {
          return setListPackage(listPackageSub);
        }
      } else {
        setListPackage(listPackageRetail);
      }
    }
  }, [selectorAccount.listPackage, tabActive, location.pathname]);

  /* callbacks */
  const afterGetUserInfo = (data, isLoading) => {
    if (!isLoading) {
      if (!data) {
        setIsLogin(data);
        // navigate(PATH.HOME);
      }
    }
  };

  const afterHandleRegisterPackage = (data, isLoading, dataError) => {
    setIsLoading(isLoading);
    // handleShowPopupMiniGameAddCoin();
    if (dataError) {
      setStateNotification({
        open: true,
        title: t("error"),
        content: dataError?.errorMessage,
      });
    } else if (data) {
      if (data?.data?.errorCode == "0") {
        setStateSuccess({
          open: true,
          title: t("success"),
          content: data?.data?.content,
        });
        if (!isCheckPackRegister.current || tabActive == TAB_KEYS.RETAIL) {
          if (data?.data?.is_show_popup) {
            // handShowPopupEvent2025();
            handleShowPopupMiniGameAddCoin(data?.data);
          }
          // handleMove();
        }
        dispatch(getTurnRemain({}));
      } else {
        setStateNotification({
          open: true,
          title: t("error"),
          content: data?.data?.content,
          errorCode: data?.data?.errorCode,
        });
      }
    }
  };

  /* handlers */
  // xử lý hiển thị popup minigame thêm coin
  const handleShowPopupMiniGameAddCoin = (data) => {
    if (!data) {
      return;
    }

    let dataAddCoin = {
      isShow: true,
      type: null,
      coin: data?.normal_coin_add || 0,
      superCoin: data?.super_coin_add || 0,
      missionName: null,
    };

    dataAddCoin.dataSelect = dataSelect?.pack_id;

    if (data?.normal_coin_add) {
      dataAddCoin.type = "normar_coin";
    }
    if (data?.super_coin_add) {
      dataAddCoin.type = "super_coin";
    }

    dataMiniAddCoins.current = dataAddCoin;

    dispatch(setPopupMission(dataAddCoin));
  };

  // xử lý chọn gói - show modal xác nhận
  const handelSelectItem = (data, isCancel) => {
    if (!isLogin && !selectorAccount.userInfo) {
      // userInfo không có (chưa login hoặc API 401) -> luôn mở popup login
      return openLogin(undefined, { force: true });
    }

    isCheckPackRegister.current = isCancel;
    setDataSelect(data);
    setIsCancelled(isCancel);
    setIsConfirmation(true);
    setStateNotification({
      open: true,
      title: t("confirmation"),
      content: t("account_page.package.confirm_buy"),
    });
  };

  // xử lý đăng ký gói
  const handleRegisterPackage = () => {
    setIsConfirmation(false);
    setStateSuccess({
      open: false,
      title: "",
      content: "",
    });

    setStateNotification({
      open: false,
      title: "",
      content: "",
    });
    let body = {
      callback: afterHandleRegisterPackage,
    };
    if (tabActive === TAB_KEYS.SUB) {
      if (isCancelled) {
        body.isRegister = false;
        body.packId = dataSelect?.pack_id;
      } else {
        body.isRegister = true;
        body.packId = dataSelect?.pack_id;
      }

      if (isMissionFromMw) {
        body.is_mission_from_mw = 1;
      }
      dispatch(registerSubPackage(body));
    } else {
      body.selectedPack = dataSelect?.pack_id;
      body.selectedPackPrice = dataSelect?.price;

      if (isMissionFromMw) {
        body.is_mission_from_mw = 1;
      }

      dispatch(registerRetailPackage(body));
    }
  };

  // xử lý thay đổi tab (mobile)
  const handleChangeTabOption = (value) => {
    setTabActive(value);
  };

  // xử lý hiển thị modal thông tin
  const handleShowInformation = () => {
    setOpenModalInfo(true);
  };

  // xử lý đóng modal thông báo
  const handleCloseNotification = () => {
    setStateNotification({
      open: false,
      title: "",
      content: "",
    });
  };

  /* conditional render */
  const showModalNotification = () => {
    const isSuccessWithValidState =
      stateNotification.title === t("success") &&
      (!isCancelled || tabActive === TAB_KEYS.RETAIL);

    const isNewUserPackageError =
      location.pathname === PATH.PACKAGE_DAILY &&
      typeIntroTour.typeActive === TYPE_USER.newDeeplink &&
      !isConfirmation;

    if (isSuccessWithValidState) {
      // return (
      //   <ModalNotifyByPackageSuccess
      //     open={stateNotification.open}
      //     handleCancel={handleCloseNotification}
      //     message={stateNotification.content}
      //     dataSelect={dataSelect}
      //   />
      // );
      return null;
    }

    if (isNewUserPackageError) {
      return (
        <ModalNotiPackageErrorNewUser
          open={stateNotification.open}
          handleCancel={handleCloseNotification}
          title={stateNotification.title}
          errorCode={stateNotification?.errorCode}
          message={stateNotification.content}
          topIcon={iconConfirm}
        />
      );
    }
    const textBtn = stateNotification?.title === t("error") ? t("bid_page.cancel") : t("bid_page.confirm");

    return (
      <ModalNotifycation
        open={stateNotification.open}
        handleCancel={handleCloseNotification}
        handleOk={isConfirmation ? handleRegisterPackage : null}
        title={stateNotification.title}
        message={stateNotification.content}
        isVersion3
        topIcon={stateNotification?.title === t("error") ? iconError : iconConfirm}
        textBtn={textBtn}
      />
    );
  };

  const showHomePage = () => isPackageDQ ? <HomePage /> : null;

  const showTabChanger = () => isPackageDQ ? null : <TabButtons tabActive={tabActive} setTabActive={setTabActive} />

  /* render */
  return (
    <>
      <Loading isLoading={isLoading} />
      <UseResponsive height={tabActive === TAB_KEYS.RETAIL ? 2400 : 1900}>
        {/* new version3 */}
        <HeaderTurnRetailPackages>
          <div className="absolute content-stretch flex flex-col gap-[32px] items-start left-[-3.25px] top-[203px] w-[880px] size-full">
            {
              // show tab changer
              showTabChanger()
            }

            <Container className="container-child-account size-full">
              {/* <BackIcon />
          <InfoIcon handleShowInformation={handleShowInformation} /> */}

              <div className="container-child-account-body">
                <div className="box-package">
                  {/* {
                // show tab changer
                showTabChanger()
              } */}
                  <TabSelectMobile
                    tabActive={tabActive}
                    handleChangeTabOption={handleChangeTabOption}
                  />
                  {/* package list */}
                  <div
                    className="content-stretch gap-[24px] items-start px-[32px] relative size-full"
                  >
                    <div className="box-package-content">
                      {listPackage.length > 0
                        ? listPackage.map((item, index) => {
                          return (
                            <div
                              key={`item_package_${item.id}_${index}`}
                              className="position-relative"
                              span={
                                isMobile || listPackage.length === 1 ? 24 : 12
                              }
                            >
                              <ItemPackage
                                isRegister={
                                  isRegister && tabActive === TAB_KEYS.SUB
                                }
                                handelSelectItem={handelSelectItem}
                                data={item}
                                type={tabActive}
                              />
                            </div>
                          );
                        })
                        : null}
                    </div>
                  </div>
                  <ContactInfo tabActive={tabActive} />
                </div>
              </div>
              {/* {
                // show home page for daily, weekly, monthly, sub package dq page
                showHomePage()
              } */}
            </Container>
          </div>
        </HeaderTurnRetailPackages>

        {/* end new version3 */}


      </UseResponsive>
      {showModalNotification()}
      <ModalLogin
        open={openModalLogin}
        setOpenModalLogin={setOpenModalLogin}
        isGetContainer={false}
      />

      {isShowPopupMissionMini && (
        <PopupMission
          isOpen={isShowPopupMissionMini}
          data={dataMiniAddCoins.current}
          getContainer
        />
      )}
      {openModalInfo && (
        <ModalInfoPage open={openModalInfo} setOpen={setOpenModalInfo} />
      )}
      {stateSuccess.open && <ModalNotifycation
        open={stateSuccess.open}
        handleCancel={() => setStateSuccess({
          open: false,
          title: "",
          content: "",
        })}
        handleOk={isConfirmation ? handleRegisterPackage : null}
        title={stateSuccess.title}
        message={stateSuccess.content}
        isVersion3
        topIcon={iconSuccess}
      />}

      <IntroTourHome />
    </>
  );
}

export default PackagePage;

const BackIcon = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  return (
    <div className="container-child-account-header">
      <div onClick={() => navigate(PATH.ACCOUNT)} className="box-title">
        <div className="icon-back" />
        <div className="box-title-text">
          {t("account_page.package.package")}
        </div>
      </div>
    </div>
  )
}

const InfoIcon = ({
  handleShowInformation = () => { }
}) => {
  return (
    <div
      className="info-icon scale-hover-item"
      onClick={handleShowInformation}
    >
      <img src={iconInfo} alt="" />
    </div>
  )
}

const Loading = ({
  isLoading
}) => {
  if (!isLoading) {
    return null;
  }
  return (
    <div className="loading">
      <Spin indicator={antIcon} />
    </div>
  )
}

const TabSelectMobile = ({ tabActive, handleChangeTabOption = () => { } }) => {
  const { t } = useTranslation();
  return (
    <div className="page-bid-action" style={{ display: "none" }}>
      <Select
        value={tabActive}
        style={{ width: 200, fontSize: "10px", marginBottom: "10px" }}
        onChange={handleChangeTabOption}
        className="select-package"
      >
        <Option value={TAB_KEYS.SUB} className="option-package">
          {t("account_page.package.sub_Package")}
        </Option>
        <Option value={TAB_KEYS.RETAIL} className="option-package">
          {t("account_page.package.retail_package")}
        </Option>
      </Select>
    </div>
  );
};

const TabButtons = ({ tabActive, setTabActive = () => { } }) => {
  const { t } = useTranslation();
  const dataTabsPackage = [
    { id: TAB_KEYS.SUB, name: t("account_page.package.sub_Package") },
    { id: TAB_KEYS.RETAIL, name: t("account_page.package.retail_package") },
  ];
  return (
    <>
      {/* ver3 */}
      <TabPackage dataTabsPackage={dataTabsPackage} tabActive={tabActive} setTabActive={setTabActive} />
      {/* end ver3 */}


      {/* <div className="box-package-tab">
      <div
        className={`box-package-tab-item ${
          tabActive === TAB_KEYS.SUB ? "active" : ""
        }`}
        onClick={() => {
          setTabActive(TAB_KEYS.SUB);
        }}
      >
        {t("account_page.package.sub_Package")}
      </div>
      <div
        className={`box-package-tab-item ${
          tabActive === TAB_KEYS.RETAIL ? "active" : ""
        }`}
        onClick={() => {
          setTabActive(TAB_KEYS.RETAIL);
        }}
      >
        {t("account_page.package.retail_package")}
      </div>
    </div> */}
    </>
  );
};

const ContactInfo = ({ tabActive }) => {
  const { t } = useTranslation();
  return (
    <ContactInfoHelper tabActive={tabActive} />
    // <div className="container-having-pack">
    //   <div className="trouble">{t("having_trouble")}</div>
    //   <div>
    //     <i class="fa fa-phone" aria-hidden="true"></i>*527# {t("dialing")} 📩
    //     527 {t("help_sending")}{" "}
    //   </div>
    //   {tabActive === "RETAIL" ? (
    //     ""
    //   ) : (
    //     <div>အစီအစဉ္ပယ်ဖျက်ရန် 527 သို့ OFF ပို့ပါ</div>
    //   )}
    // </div>
  );
};

// const EventFlyContainer = ({ totalFly }) => {
//   return (
//     <>
//       {/* {+configEventLuckyMoon.is_show === 1 &&
//       !configEventLuckyMoon?.is_finished ? (
//         <Div
//           style={{
//             opacity: `${
//               stateNotifycation.title == t("success") &&
//               !isCheckPackRegister.current
//                 ? "1"
//                 : "0"
//             }`,
//           }}
//         >
//           <div
//             className="image-fly"
//             id="imgFlyContainer"
//             style={{ transform: "translate(-50%, -50%)" }}
//             ref={movingItemRef}
//           >
//             <img src={iconFly} alt="" className="abc" />
//             <div className="total-flys">{handleGetTotalFly()}</div>
//           </div>
//         </Div>
//       ) : null} */}

//         {/* {stateNotifycation.title == t("success") &&
//       (!isCheckPackRegister.current || tabActive === "RETAIL") ? (
//         <AddItemEvent2024 total={handleGetTotalFly("event-2024-new-year")} />
//       ) : null} */}
//     </>
//   )
// };

const Container = styled.div`
  position: relative;

  .container-home__page-package-daily {
    margin-top: -50px;

    .container-home-current-product-content-upcoming {
      padding-bottom: 10px;
    }
  }

  .info-icon {
    position: absolute;
    right: 25px;
    top: 15px;
    cursor: pointer;
  }

  .container-having-pack {
    background-color: #dedede;
    border-radius: 50px;
    max-width: 500px;
    width: 100%;
    padding: 4px;
    margin: 0 auto;
    color: #575757;
    text-align: center;
    font-size: 14px;
    margin-top: 26px;
    line-height: 26px;
    z-index: 1;

    .trouble {
      text-align: center;
      font-weight: 600;
    }

    @media (max-width: 992px) {
      margin-top: 10px;
    }

    @media (max-width: 576px) {
      font-size: 12px;
      margin-top: 0;
      border-radius: 40px;
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
      position: fixed;
      bottom: 98px;
      line-height: 20px;
      left: 0;
      max-width: 576px;
    }
  }

  .popup-cong-mini {
    width: 100%;
  }

  @media (max-width: 576px) {
    .box-package-content {
      /* padding-bottom: 55px; */
    }

    .info-icon img {
      width: 25px;
    }
  }

  @media (max-width: 500px) {
    .img-coins {
      max-width: 50%;
      margin: 12px auto;
    }

    .button-action-cong-content {
      font-size: 14px !important;
    }

    .popup-cong-mini {
      .bg {
        min-height: 530px;
      }
    }

    .popup-cong-mini-main {
      width: calc(100% - 50px);
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      top: 150px;
    }

    .content-coins {
      line-height: 48px;
      padding: 12px 0;
      padding-bottom: 0;
    }

    .content-main-last {
      height: 44px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  @media (max-width: 450px) {
    .popup-cong-mini {
      .bg {
        min-height: 480px;
      }
    }
  }

  @media (max-width: 360px) {
    .popup-cong-mini {
      .bg {
        min-height: 420px;
      }
    }
  }
`;

const Div = styled.div`
  .image-fly {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 9998;
    pointer-events: none;
  }

  .total-flys {
    position: absolute;
    top: 25px;
    left: 50%;
    transform: translateX(-50%);

    filter: drop-shadow(2px 0 0 rgba(135, 0, 0, 1))
      drop-shadow(-2px 0 0 rgba(135, 0, 0, 1))
      drop-shadow(0 2px 0 rgba(135, 0, 0, 1))
      drop-shadow(0 -2px 0 rgba(135, 0, 0, 1));
    color: white;
    font-size: 45px;
  }

  @media (max-width: 768px) {
    img {
      width: 110px;
    }

    .total-flys {
      font-size: 32px;
    }
  }
`;
